module.exports = __webpack_public_path__ + "img/10.07d89af9.jpg";